import styled from '@emotion/styled'

export const ApprovedEInvoiceEmptyStateWrapper = styled.section`
  height: 624px;
`
